// extracted by mini-css-extract-plugin
export var phone = "_2d-0";
export var phoneDragging = "_2d-1";